module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/step2-e98c2b028e63c71b64fc663bf1b76a2c.svg";